// SPDX-License-Identifier: AGPL-3.0-or-later

import Emoji from '@app/features/emoji/state/Emoji';
import EmojiPicker, {UNICODE_EMOJI_USAGE_KEY_PREFIX} from '@app/features/emoji/state/EmojiPicker';
import type {FlatEmoji} from '@app/features/emoji/types/EmojiTypes';
import UnicodeEmojis from '@app/features/expressions/utils/UnicodeEmojis';
import type {ReactionEmoji} from '@app/features/messaging/utils/ReactionUtils';

export function resolveReactionEmojiForUsage(emoji: ReactionEmoji): FlatEmoji | null {
	if (emoji.id) {
		return Emoji.getEmojiById(emoji.id) ?? null;
	}
	const surrogate = UnicodeEmojis.normalizeEmojiNameToSurrogate(emoji.name);
	const name = UnicodeEmojis.getSurrogateName(surrogate);
	if (!name) {
		return null;
	}
	const unicode = UnicodeEmojis.getByName(name);
	if (!unicode?.uniqueName) {
		return null;
	}
	return Emoji.getEmojiByUsageKey(`${UNICODE_EMOJI_USAGE_KEY_PREFIX}${unicode.uniqueName}`) ?? null;
}

/**
 * A reaction carries wire shape, not a picker emoji, so the usage key has to be resolved
 * first: skin-toned surrogates collapse onto their base name and custom reactions need their
 * guild scope. Unresolvable reactions are dropped rather than tracked under a bad key.
 */
export function trackReactionEmojiUsage(emoji: ReactionEmoji): void {
	const resolved = resolveReactionEmojiForUsage(emoji);
	if (!resolved) {
		return;
	}
	EmojiPicker.trackEmoji(resolved);
}
